import QuizBanners from "@/components/banners/quiz-banners";
import CompanyMeta from "@/components/company-meta";
import DimensionsBentoGrid from "@/components/dimensions-bento";
import EmptyState from "@/components/empty-state";
import PageHeader from "@/components/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCompanyById } from "@/hooks/company-by-id.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { ClipboardText, Send2 } from "iconsax-react";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { Link } from "react-router-dom";
import SendQuizDialog from "../../components/send-quiz-dialog";

const QuizPage = () => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const [showSendQuizDialog, setShowSendQuizDialog] = useState(false);

  const { data: userProfile } = useCurrentUserProfile();

  const {
    data: application,
    isLoading: isApplicationLoading,
    isSuccess: isApplicationSuccess,
    isError: isApplicationError,
    error: applicationError,
  } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId: editionId,
  });

  const { data: quiz, isLoading: isQuizLoading } = useQuizById({
    companyId: application?.company.id || "",
    applicationQuizId: application?.quizId || "",
  });

  const { data: company, isLoading: isCompanyLoading } = useCompanyById(
    userProfile?.companyId || "",
  );

  const isLoading = isCompanyLoading || isApplicationLoading || isQuizLoading;

  const handleSubmitQuiz = () => {
    setShowSendQuizDialog(true);
  };

  if (isApplicationError) {
    throw applicationError;
  }

  return (
    <>
      <PageHeader
        className="mb-4"
        title={`Cuestionario de evaluación: ${application?.edition.name}`}
        icon={<ClipboardText />}
        afterHeading={<CompanyMeta company={company} isLoading={isLoading} />}
      >
        {isLoading ? (
          <Skeleton
            className="bg-gray-200"
            style={{ width: "182px", height: "40px" }}
          />
        ) : (
          <>
            {quiz?.status === "READY" && (
              <Button onClick={handleSubmitQuiz}>
                <Send2 size={18} />
                Enviar cuestionario
              </Button>
            )}
          </>
        )}
      </PageHeader>

      {isApplicationSuccess &&
        (application?.quizId ? (
          <>
            <QuizBanners className="mb-6" />

            <DimensionsBentoGrid
              companyId={application.company.id}
              applicationQuizId={application.quizId}
              showExtraInfo={true}
              showScoreProportionInHeader={false}
            />

            <SendQuizDialog
              showDialog={showSendQuizDialog}
              showDialogChange={setShowSendQuizDialog}
              quizId={application.quizId}
            />
          </>
        ) : (
          <EmptyState
            className="m-auto"
            message="El cuestionario al que intentas entrar no existe."
          >
            <Button variant={"secondary"} className="mt-4" asChild>
              <Link to={"/"}>Volver a la página principal</Link>
            </Button>
          </EmptyState>
        ))}
    </>
  );
};

export default QuizPage;
